module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.f49b3534.svg";